module.exports = __webpack_public_path__ + "img/2.08e4be0b.jpg";